const GRAPHIC_ORGANIZER_GRADE_BANDS = {
  ALL: ["K", 12],
  ES: [1, 5],
  "ES-MS": [1, 8],
  MS: [6, 8],
  "MS-HS": [6, 12],
  HS: [9, 12],
};

export default GRAPHIC_ORGANIZER_GRADE_BANDS;
